// extracted by mini-css-extract-plugin
export default {"kontener":"style_kontener__XzI04","pelny":"style_pelny__za22y","znak":"style_znak__vCI4T","oddech":"style_oddech__xxd4T","dlaCzytnika":"style_dlaCzytnika__AZ1qm"};